import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuelRealtimeConsumptionPopupComponent } from './fuel-realtime-consumption-popup.component';
import {DxPopupModule} from 'devextreme-angular';
import {FuelRealtimeConsumptionModule} from '../fuel-realtime-consumption/fuel-realtime-consumption.module';



@NgModule({
  declarations: [FuelRealtimeConsumptionPopupComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    FuelRealtimeConsumptionModule
  ],
  exports: [FuelRealtimeConsumptionPopupComponent]
})
export class FuelRealtimeConsumptionPopupModule { }
